var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSquare3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 304,
    height: 311,
    viewBox: "0 0 304 311",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 148.481,
    y: 257.287,
    width: 72,
    height: 72,
    transform: "rotate(-42.7751 148.481 257.287)",
    stroke: "#F01A33"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 99.5843,
    y: 204.437,
    width: 72,
    height: 72,
    transform: "rotate(-42.7751 99.5843 204.437)",
    stroke: "#F01A33"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 152.434,
    y: 155.541,
    width: 72,
    height: 72,
    transform: "rotate(-42.7751 152.434 155.541)",
    stroke: "#F01A33"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 103.537,
    y: 102.691,
    width: 72,
    height: 72,
    transform: "rotate(-42.7751 103.537 102.691)",
    stroke: "#F01A33"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 50.6027,
    y: 151.454,
    width: 72,
    height: 72,
    transform: "rotate(-42.7751 50.6027 151.454)",
    stroke: "#F01A33"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 1.70584,
    y: 98.6037,
    width: 72,
    height: 72,
    transform: "rotate(-42.7751 1.70584 98.6037)",
    stroke: "#F01A33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquare3);
export default __webpack_public_path__ + "static/media/square__3.010352b94f037b6819a13853d27394b0.svg";
export { ForwardRef as ReactComponent };